// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pip-code';

export const resetPipCode = () => ({
    data: getDefaultState(),
    type: actions.RESET_PIP_CODE
});



// WEBPACK FOOTER //
// ./src/pip/pip-code/action-creators/reset-pip-code.js